import { ParametreOperationDto } from './parametre-operation.dto';

export class OperationAdminDto {
	codeTypeOperationAdmin: string;
	inclureAdmin: boolean;
	parametres: ParametreOperationDto[];
	tous: boolean;

	constructor(codeTypeOperationAdmin?: string, parametres?: ParametreOperationDto[], inclureAdmin?: boolean, tous?: boolean) {
		this.codeTypeOperationAdmin = codeTypeOperationAdmin;
		this.parametres = parametres;
		this.inclureAdmin = inclureAdmin;
		this.tous = tous;
	}

	deserialize(input: any): OperationAdminDto {
		Object.assign(this, input);

		if (input.parametres) {
			this.parametres = input.parametres.map(parametre => new ParametreOperationDto(parametre.cle, parametre.valeur));
		}

		return Object.setPrototypeOf(this, OperationAdminDto.prototype);
	}

	/**
	 * Retourne true si l'utilisateur doit être déconnecté.
	 *
	 * @param login le login de l'utilisateur connecté.
	 * @return {boolean} true si l'utilisateur doit être déconnecté.
	 */
	doitDeconnecter(login: string): boolean {
		return this.tous || (login != null && this.recupererParametre('logins').split(',').includes(login));
	}

	/**
	 * Retourne la valeur du paramètre de l'opération admin.
	 *
	 * @param cle la clé de paramètre de l'opération admin.
	 * @return {string} la valeur du paramètre
	 */
	recupererParametre(cle: string): string {
		const parametreParCle: Map<string, string> = new Map();
		this.parametres.forEach(parametre => {
			parametreParCle.set(parametre.cle, parametre.valeur);
		});

		return parametreParCle.get(cle);
	}
}
